import { render } from "./PrivacyPage.vue?vue&type=template&id=f934b1a4"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__